export enum BoletaStatus {
    AGUARDANDO_MESA = "aguardando-mesa",
    PRE_RESERVADO = "pre-reservado",
    DISPONIVEL = "disponivel",
    RESERVADO = "reservado",
    DELETADO = "deletado",
    AGUARDANDO_REVALIDACAO = "aguardando-revalidacao",
    ATIVO_INEXISTENTE = "ativo-inexistente",
    FINALIZADO = "finalizado",
    FECHADO_SEM_INTERMEDIACAO = "fechado-sem-intermediacao",
}

export const BOLETA_STATUS_LABELS: { [key in BoletaStatus]: string } = {
    [BoletaStatus.AGUARDANDO_MESA]: "Aguardando Mesa",
    [BoletaStatus.PRE_RESERVADO]: "Pré-Reservado",
    [BoletaStatus.DISPONIVEL]: "Disponível",
    [BoletaStatus.RESERVADO]: "Reservado",
    [BoletaStatus.DELETADO]: "Deletado",
    [BoletaStatus.AGUARDANDO_REVALIDACAO]: "Aguardando Revalidação",
    [BoletaStatus.ATIVO_INEXISTENTE]: "Ativo Inexistente",
    [BoletaStatus.FINALIZADO]: "Finalizado",
    [BoletaStatus.FECHADO_SEM_INTERMEDIACAO]: "Fechado sem Intermediação",
};
